/******************************************************************************
 *** LeftMenu ** Left Menu
*******************************************************************************/
import { useRecoilValue } from "recoil";
import * as Atom from "@/js/common/Atom";
import AppContext from "@/js/common/AppContext";
import { useLocation, useNavigate } from "react-router-dom";
import React from "react";
import SystemMenu from "@/js/system/common/SystemMenu";
import Span from "@/js/common/ui/Span";
import Modal from "@/js/common/ui/modal/Modal";
import DialogTitleBar from "./DialogTitleBar";
import MyInfoDialog from "./dialog/MyInfoDialog";
import Axios from "@/js/common/Axios";
import MainPage from "@/js/portal/MainPage";
import ChangePswdDialog from "./dialog/ChangePswdDialog";

const LeftMenu = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const userInfo = useRecoilValue(Atom.userInfo);
    const selectedSystemId = typeof location.state?.selectedSystemId === "string" ? location.state.selectedSystemId : "";
    const [userRoles, setUserRoles] = React.useState<any[]>([]); // 회원 권한 배열
    const [myInfoModalOpen, setMyInfoModalOpen] = React.useState<boolean>(false); // MY INFO 모달
    const [pswdModalOpen  , setPswdModalOpen  ] = React.useState(false); // 비밀번호 수정 모달
    const userId = userInfo.userId;
    const [systemId  , setSystemId  ] = React.useState<string>(""); // System ID
    const [systemName, setSystemName] = React.useState<string>(""); // System ID

    const [orgSystemModalOpen, setOrgSystemModalOpen] = React.useState(false); // 시스템 선택모달 열림 여부

    const [subSystems, setSubSystems] = React.useState<any[]>([]); // 결재자 조회 시스템


    // 회원 상세정보 조회
    React.useEffect(() => {
        AppContext.showSpinner();
        Axios.dataAccess({
            url        : "system/mbr/mng/select-mbr-aprv-wtng-dtl.do",
            methodType : "post",
            paramType  : "json",
            paramData  : {
                userId: userId,
            },
            onSuccessFn: (res: any) => {
                if (res.result.item.auth01Yn === "Y") setUserRoles(prev => [...prev, 'BUDGET_ADMIN'     ]); // 조합비 관리자
                if (res.result.item.auth02Yn === "Y") setUserRoles(prev => [...prev, 'BUDGET_APPROVER'  ]); // 조합비 결재자
                if (res.result.item.auth03Yn === "Y") setUserRoles(prev => [...prev, 'BUDGET_VIEWER'    ]); // 조합비 조회자
                if (res.result.item.auth04Yn === "Y") setUserRoles(prev => [...prev, 'MEMBER_ADMIN'     ]); // 조합원 관리자
                if (res.result.item.auth05Yn === "Y") setUserRoles(prev => [...prev, 'MEMBER_APPROVER'  ]); // 조합원 결재자
                if (res.result.item.auth06Yn === "Y") setUserRoles(prev => [...prev, 'MEMBER_VIEWER'    ]); // 조합원 조회자
                if (res.result.item.auth07Yn === "Y") setUserRoles(prev => [...prev, 'HEAD_OFFICE_ADMIN']); // 본부 관리자
                if (res.result.item.auth08Yn === "Y") setUserRoles(prev => [...prev, 'SYSTEM_ADMIN'     ]); // 시스템관리자
                AppContext.hideSpinner();
            },
        });
    }, [userId]);

    // 결재자 조회 시스템 확인
    React.useEffect(() => {
        const sysCUse = [userInfo.sysAuthrtC1Yn, userInfo.sysAuthrtC2Yn, userInfo.sysAuthrtC3Yn, userInfo.sysAuthrtC4Yn, userInfo.sysAuthrtC5Yn].some(auth => auth === "Y") ? "Y" : "N";
        const systemA = userInfo.sysAuthrtA1Yn; // 총괄 교부금 사용 여부
        const systemB = userInfo.sysAuthrtB1Yn; // 운영비 사용 여부
        const systemC = sysCUse               ; // 특별회계기금 사용 여부
        const systemD = userInfo.sysAuthrtD1Yn; // 조합원 사용 여부
        const systemE = userInfo.sysAuthrtE1Yn; // 지부 운영비
        const systemF = userInfo.sysAuthrtF1Yn; // 지부장 직무활동비
        const systemG = userInfo.sysAuthrtG1Yn; // 지부 대회비
        if (systemA === "Y") setSubSystems(prev => [...prev, 'A']); // 총괄 교부금
        if (systemB === "Y") setSubSystems(prev => [...prev, 'B']); // 운영비
        if (systemC === "Y") setSubSystems(prev => [...prev, 'C']); // 특별회계기금
        if (systemD === "Y") setSubSystems(prev => [...prev, 'D']); // 조합원
        if (systemE === "Y") setSubSystems(prev => [...prev, 'E']); // 지부 운영비
        if (systemF === "Y") setSubSystems(prev => [...prev, 'F']); // 지부장 직무활동비
        if (systemG === "Y") setSubSystems(prev => [...prev, 'G']); // 지부 대회비
    }, [userInfo]);

    // 시스템 ID & 이름 설정
    React.useEffect(() => {
             if (location.pathname.includes("A1")) { setSystemId("A1"); setSystemName("총괄 교부금"   ); }
        else if (location.pathname.includes("B1")) { setSystemId("B1"); setSystemName("운영비"        ); }
        else if (location.pathname.includes("C1")) { setSystemId("C1"); setSystemName("복지기금"      ); }
        else if (location.pathname.includes("C2")) { setSystemId("C2"); setSystemName("자립기금"      ); }
        else if (location.pathname.includes("C3")) { setSystemId("C3"); setSystemName("발전기금"      ); }
        else if (location.pathname.includes("C4")) { setSystemId("C4"); setSystemName("희생자 부조금" ); }
        else if (location.pathname.includes("C5")) { setSystemId("C5"); setSystemName("퇴직급여충당금"); }
        else if (location.pathname.includes("D1")) { setSystemId("D1"); setSystemName("조합원"        ); }
        else if (location.pathname.includes("E1")) { setSystemId("E1"); setSystemName("지부 운영비"   ); }
        else if (location.pathname.includes("F1")) { setSystemId("F1"); setSystemName("지부장 직무활동비"); }
        else if (location.pathname.includes("G1")) { setSystemId("G1"); setSystemName("지부 대회비"   ); }
        else                                       { setSystemId("E" ); setSystemName("결재 문서함"   ); }
    }, [location.pathname, systemId, userRoles]);

    return (
        <div className="bgc404855" style={{maxWidth: "200px", minWidth: "200px"}}>
            {/* 시스템 선택 {navigate('/') */}
            <div className="dpFlx aiC jcC bd1 h30 bdrd5 bdcDDDDDD ml20 mt20 mr20 csP op60-hover" style={{backgroundColor: "#1F2937"}} onClick={() => setOrgSystemModalOpen(true)}>
                <p className="fm-c fs16 taC" style={{color: "orange"}}>{systemName}</p>
            </div>
            {/* 로그아웃 */}
            <div className="dpFlx aiC jcC h30 ml20 mr20 mt10">
                <span className="fm-b fs13 fcWhite ls06">{userInfo.userNm} 님</span>
                <button className="bdN bgcBlack h25 bdrd5 ml10" onClick={() => {
                    AppContext.openAlert({
                        title: "로그아웃",
                        msg: "로그아웃 하시겠습니까?",
                        icon: "check",
                        confirmText: "로그아웃",
                        handleConfirm: AppContext.goLogout
                    });
                }}>
                    <span className="fm-b fs12 ls06 fcWhite">로그아웃</span>
                </button>
            </div>

            {/* MY INFO */}
            <div className="dpFlx aiC jcC h30 ml20 mr20" onClick={() => setMyInfoModalOpen(true)}>
                <button className="bdN bgc9098A7 h25 bdrd5 mt10 w100"><span className="fm-c fs12 ls01 fcWhite">MY INFO</span></button>
            </div>

            {/* 구분 Line */}
            <div className="pw22 bsBdb mb10">
                <div className="w100p h1 bgc545C6A mt10"></div>
            </div>

            {/* 메뉴 네비게이션 */}
            {SystemMenu.menuList.filter(item => item.isVisible
                    && item.allowedRoles.some(role => userRoles.includes(role))      // 사용자 권한 확인
                    && item.allowedSystem.includes(systemId)                           // 선택한 시스템
                    && item.allowedSubSystem.some(role => subSystems.includes(role))    // 조직의 가능한 시스템
                    && (!item.targetSystem || item.targetSystem === selectedSystemId))
                .map((systemMenu: any, idx: number) => {
                const isMenuSel = SystemMenu.getMainMenuUrlBySubMenuUrl(location.pathname) === systemMenu.url || SystemMenu.getMainMenuUrlByDetailMenuUrl(location.pathname) === systemMenu.url;
                return (
                    <React.Fragment key={idx}>
                        <button
                            key={idx}
                            className={"w100p h42 dpFlx aiC jcFs pw20 " + (isMenuSel ? "bgc313946" : "bgc404855")}
                            onClick={() => navigate(systemMenu.url, systemMenu.allowedSystem.includes("E") ? { state: { ...location.state, selectedSystemId } } : undefined)}
                        >
                            <i className={"admin-icon mr10 " + systemMenu.iconClass}></i>
                            <Span fontFamily="Pretendard-Regular" fontSize={14} letterSpacing={-1} color={isMenuSel ? "#fff" : "#B3B9C2"}>
                                {systemMenu.name}
                            </Span>
                        </button>
                        {systemMenu.subMenuList.filter((subItem: any) => subItem.isVisible && (!subItem.headOfficeOnly || (userInfo.ognzCd ?? "").includes("000"))).map((subMenu: any, sidx: number) => {
                            if (isMenuSel) {
                                const isSubMenuSel = location.pathname === subMenu.url || location.pathname.indexOf(subMenu.url) !== -1;
                                return (
                                    <button
                                        key={sidx}
                                        className={"w100p h42 dpFlx aiC jcFs pw20 " + (isSubMenuSel ? "bgc262E3B" : "bgc313946")}
                                        onClick={() => navigate(subMenu.url, systemMenu.allowedSystem.includes("E") ? { state: { ...location.state, selectedSystemId } } : undefined)}
                                    >
                                        <Span
                                            fontFamily="Pretendard-Regular"
                                            fontSize={14}
                                            letterSpacing={-1}
                                            color={isSubMenuSel ? "#fff" : "#B3B9C2"}
                                            style={{paddingLeft: 30}}
                                        >
                                            {subMenu.name}
                                        </Span>
                                    </button>
                                )
                            }
                        })}
                    </React.Fragment>
                )
            })}
            <div style={{width: "100%", height: 100, backgroundColor: "#404855"}}></div>

            {/* 회원 상세정보 모달 */}
            <Modal modalOpen={myInfoModalOpen} dim={true} visible={true} width={640}
                titleEl={<DialogTitleBar title={"회원 상세정보"}/>}
                onCloseFunc={() => setMyInfoModalOpen(false)}
            >
                <MyInfoDialog userId={userId} setMyInfoModalOpen={setMyInfoModalOpen} setPswdModalOpen={setPswdModalOpen}/>
            </Modal>

            <Modal modalOpen={pswdModalOpen} dim={true} visible={true}
                titleEl={<DialogTitleBar title="비밀번호 수정" backgroundColor={AppContext.themeColor} />}
                onCloseFunc={() => {
                    setPswdModalOpen(false);
                    setMyInfoModalOpen(true);
                }}
            >
                <ChangePswdDialog userId={userId} setPswdModalOpen={setPswdModalOpen} setMyInfoModalOpen={setMyInfoModalOpen}/>
            </Modal>

            {/* 기관 시스템 선택 모달 */}
            <Modal modalOpen={orgSystemModalOpen} dim={true} visible={true}
                width={window.innerWidth <= 768 ? Math.min(window.innerWidth - 24, 420) : 820}
                titleEl={<DialogTitleBar title={"시스템 정보"}/>}
                onCloseFunc={() => setOrgSystemModalOpen(false)}
            >
                <div
                    style={{
                        width: window.innerWidth <= 768 ? "calc(100vw - 100px)" : "770px",
                        maxWidth: "100%",
                        height: window.innerWidth <= 768 ? "calc(100vh - 120px)" : "560px",
                        overflowY: "auto",
                        overflowX: "hidden",
                        boxSizing: "border-box"
                    }}
                >
                    <MainPage
                        setSystemId={setSystemId}
                        setSystemName={setSystemName}
                        setOrgSystemModalOpen={setOrgSystemModalOpen}
                    />
                </div>
            </Modal>

        </div>
    )
}
export default LeftMenu;